import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import './fonts/Montserrat-Thin.ttf';
import './fonts/Montserrat-Light.ttf';
import './fonts/Montserrat-ExtraLight.ttf';
import './fonts/Montserrat-Regular.ttf';
import './fonts/Montserrat-Medium.ttf';
import './fonts/Montserrat-Bold.ttf';
import './fonts/Montserrat-Black.ttf';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<>

    <App />
    </>
);


